<div class="page has-title">
  <h1>{{ title }}</h1>
  <small>
    <span
      [innerHTML]="
        'Please migrate <strong>your equipment items</strong> to AstroBin\'s new database, in order to remove ' +
          'duplication and fragmentation.' | translate
      "
    ></span>

    <a href="https://welcome.astrobin.com/blog/the-great-equipment-database-migration-of-2021" target="_blank">
      {{ "Learn more" | translate }}.
    </a>
  </small>

  <div class="row">
    <div class="col-md-3">
      <astrobin-migration-nav></astrobin-migration-nav>

      <astrobin-equipment-item-type-nav
        [accessoryCount]="nonMigratedAccessoriesCount$"
        [cameraCount]="nonMigratedCamerasCount$"
        [excludeTypes]="[EquipmentItemType.SENSOR]"
        [filterCount]="nonMigratedFiltersCount$"
        [mountCount]="nonMigratedMountsCount$"
        [showBrands]="false"
        [showContributors]="false"
        [showSubNavigation]="false"
        [softwareCount]="nonMigratedSoftwareCount$"
        [telescopeCount]="nonMigratedTelescopesCount$"
        routingBasePath="/equipment/migration-tool"
      ></astrobin-equipment-item-type-nav>
    </div>

    <div class="col-md-7">
      <ng-container [ngTemplateOutlet]="randomNonMigrated"></ng-container>
      <ng-container [ngTemplateOutlet]="myMigrations"></ng-container>
    </div>
    <!-- main col -->

    <div class="col-md-2">
      <astrobin-migration-guidelines></astrobin-migration-guidelines>
    </div>
    <!-- guidelines col -->
  </div>
  <!-- main row -->
</div>
<!-- page -->

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #allDone>
  <div class="alert alert-info">
    <p>{{ "There are no more items of this type to migrate. Check other equipment types." | translate }}</p>
  </div>
</ng-template>

<ng-template #randomNonMigrated>
  <ng-container *ngIf="randomNonMigrated$ | async as randomNonMigrated; else loading">
    <ng-container *ngIf="!!randomNonMigrated?.item; else allDone">
      <div
        [class.disabled]="migrationMode || subCreationMode || migrationConfirmation.inProgress"
        class="card box-shadow"
      >
        <div class="card-header">
          {{ "This is an item in the OLD database and it might be poorly defined" | translate }}
        </div>

        <div class="card-body">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="col">{{ "Item class" | translate }}</th>
                <td>{{ legacyGearService.humanizeType(activeType) }}</td>
              </tr>
              <tr>
                <th scope="col">{{ "Brand/Make" | translate }}</th>
                <td>{{ randomNonMigrated.item.make || "n/a" | translate }}</td>
              </tr>
              <tr>
                <th scope="col">{{ "Name/Model" | translate }}</th>
                <td>{{ randomNonMigrated.item.name || "n/a" | translate }}</td>
              </tr>
              <tr *ngIf="randomNonMigrated.userInfo?.alias">
                <th scope="col">{{ "Alias" | translate }}</th>
                <td>{{ randomNonMigrated.userInfo.alias || "n/a" | translate }}</td>
              </tr>
              <tr *ngIf="randomNonMigrated.userInfo?.comment">
                <th scope="col">{{ "Comment" | translate }}</th>
                <td>{{ randomNonMigrated.userInfo.comment || "n/a" | translate }}</td>
              </tr>
              <tr *ngIf="randomNonMigrated.userInfo?.modded">
                <th scope="col">{{ "Modified" | translate }}</th>
                <td>{{ "Yes" | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-footer">
          <button
            [class.loading]="loadingService.loading$ | async"
            [disabled]="migrationMode || subCreationMode || migrationConfirmation.inProgress"
            (click)="skip(randomNonMigrated.item)"
            class="btn btn-sm-block btn-secondary"
          >
            <fa-icon icon="sync"></fa-icon>
            {{ "Get next" | translate }} ({{ "random" | translate }})
          </button>

          <div class="d-inline-block" ngbDropdown>
            <button
              [class.loading]="loadingService.loading$ | async"
              [disabled]="migrationMode || subCreationMode || migrationConfirmation.inProgress"
              id="mark-as-dropdown-button"
              class="btn btn-sm-block btn-secondary"
              ngbDropdownToggle
            >
              <fa-icon icon="tag"></fa-icon>
              {{ "Mark as" | translate }}&hellip;
            </button>

            <div [attr.aria-labelledby]="'mark-as-dropdown-button'" ngbDropdownMenu>
              <a (click)="markAsMultiple($event, randomNonMigrated.item)" class="dropdown-item" href="">
                {{ "Multiple items" | translate }}
                <span [ngbTooltip]="multipleTooltip()" class="help-tooltip">
                  <fa-icon icon="question-circle"></fa-icon>
                </span>
              </a>

              <a (click)="markAsNotEnoughInfo($event, randomNonMigrated.item)" class="dropdown-item" href="">
                {{ "Not enough info" | translate }}
                <span [ngbTooltip]="notEnoughInfoTooltip()" class="help-tooltip">
                  <fa-icon icon="question-circle"></fa-icon>
                </span>
              </a>
            </div>
          </div>

          <span class="or d-none d-lg-block">{{ "or" | translate }}</span>

          <button
            [class.loading]="loadingService.loading$ | async"
            [disabled]="migrationMode || subCreationMode || migrationConfirmation.inProgress"
            (click)="beginMigration()"
            class="btn btn-sm-block btn-primary"
          >
            <fa-icon icon="arrow-right"></fa-icon>
            {{ "Begin" | translate }}&hellip;
          </button>
        </div>
      </div>

      <div [hidden]="migrationMode || migrationConfirmation.inProgress" class="mt-2 alert alert-info">
        <fa-icon icon="info-circle"></fa-icon>
        {{
          "If you're not sure how to use this page, feel free to contact AstroBin or just skip it and let AstroBin moderators deal with your equipment later."
            | translate
        }}
      </div>

      <ng-container *ngIf="migrationMode">
        <div class="mt-4 mb-4 text-center">
          <fa-icon icon="arrow-down"></fa-icon>
        </div>

        <div
          [class.disabled-with-backdrop]="subCreationMode || migrationConfirmation.inProgress"
          id="select-item-to-migrate-to"
          class="card"
        >
          <div class="backdrop"></div>

          <div class="card-header">
            {{ "Begin migration" | translate }}
          </div>

          <div class="card-body">
            <astrobin-equipment-item-browser
              #equipmentItemBrowser
              [description]="
                'Remember: you want to match items from the old database products in the new database.' | translate
              "
              [enableFullscreen]="true"
              [label]="'Please find a corresponding equipment item in the NEW database' | translate"
              [layout]="ItemBrowserLayout.VERTICAL"
              [required]="true"
              [showItemTypeSelector]="true"
              [type]="getActiveType()"
              (subCreationModeEnded)="subCreationMode = false"
              (subCreationModeStarted)="subCreationMode = true"
              (valueChanged)="this.migrationTarget = $event"
            ></astrobin-equipment-item-browser>
          </div>

          <div class="card-footer">
            <button
              [class.loading]="loadingService.loading$ | async"
              [disabled]="subCreationMode || migrationConfirmation.inProgress"
              (click)="cancelMigration()"
              class="btn btn-sm-block btn-secondary"
            >
              {{ "Cancel" | translate }}
            </button>

            <button
              [class.loading]="loadingService.loading$ | async"
              [disabled]="!migrationTarget || subCreationMode || migrationConfirmation.inProgress"
              (click)="beginMigrationConfirmation(randomNonMigrated.item)"
              class="btn btn-sm-block btn-primary"
            >
              {{ "Confirm migration" | translate }}&hellip;
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="migrationConfirmation.inProgress">
        <div class="mt-4 mb-4 text-center">
          <fa-icon icon="arrow-down"></fa-icon>
        </div>

        <div class="mt-4 mb-4">
          <div id="confirm-migration" class="card">
            <div class="card-header">
              {{ "Confirm migration" | translate }}
            </div>

            <div class="card-body">
              <div
                [innerHTML]="
                  'We found more items in the legacy database that are similar to the one you are migrating. ' +
                    'Please check the ones that you want to migrate along! <strong>Please be careful!</strong> Not ' +
                    'all items that AstroBin thinks are similar, are necessarily the same product. Only check the ' +
                    'ones that you are sure of.' | translate
                "
                class="alert alert-info"
              ></div>

              <h5 class="mt-5 mb-4">{{ "Legacy item being migrated" | translate }}</h5>

              <div class="custom-control custom-checkbox">
                <input
                  id="legacy-item-being-migrated"
                  class="custom-control-input"
                  checked
                  disabled="disabled"
                  type="checkbox"
                />
                <label class="custom-control-label" for="legacy-item-being-migrated">
                  {{ legacyGearService.getDisplayName(randomNonMigrated.item.make, randomNonMigrated.item.name) }}
                </label>
              </div>

              <h5 class="mt-5 mb-4">Similar legacy items</h5>

              <form [formGroup]="migrationConfirmation.form">
                <formly-form
                  [fields]="migrationConfirmation.fields"
                  [form]="migrationConfirmation.form"
                  [model]="migrationConfirmation.model"
                ></formly-form>
              </form>
            </div>

            <div class="card-footer">
              <button
                [class.loading]="loadingService.loading$ | async"
                (click)="resetMigrationConfirmation()"
                class="btn btn-sm-block btn-secondary"
              >
                {{ "Cancel" | translate }}
              </button>

              <button
                [class.loading]="loadingService.loading$ | async"
                [disabled]="!migrationConfirmation.form.valid"
                (click)="confirmMigration(randomNonMigrated.item)"
                class="btn btn-sm-block btn-primary"
              >
                {{ "Confirm selected migrations" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #myMigrations>
  <ng-container *ngIf="allStrategies$ | async as allStrategies; else loading">
    <div *ngIf="!migrationMode && allStrategies.count > 0" class="card mt-5">
      <div class="card-header">{{ "Your most recent applied migrations (all equipment classes)" | translate }}</div>
      <div class="card-body">
        <table class="table table-striped applied-migrations">
          <thead>
            <tr>
              <td>ID</td>
              <td>{{ "Legacy item" | translate }}</td>
              <td>{{ "Strategy" | translate }}</td>
              <td>{{ "New item" | translate }}</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let strategy of allStrategies.results">
              <td>{{ strategy.pk }}</td>
              <td>
                <strong>{{ strategy.gear.make }}</strong> {{ strategy.gear.name }}
              </td>
              <td>{{ strategy.migrationFlag }}</td>
              <td>
                <ng-container *ngIf="!!strategy.migrationContentObjectBrand; else notAvailable">
                  <astrobin-equipment-item-display-name
                    [item]="strategy.migrationContentObject"
                  ></astrobin-equipment-item-display-name>
                </ng-container>
              </td>
              <td>
                <button
                  [class.loading]="loadingService.loading$ | async"
                  (click)="undoMigration(strategy)"
                  class="btn btn-sm btn-outline-secondary"
                >
                  {{ "Undo" | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #notAvailable>
  <span>{{ "n/a" | translate }}</span>
</ng-template>
